import Input from '@ui/forms/Input'
import { useWatch } from 'react-hook-form'
import { getPrismLensPd } from './calculateBase'
import { WIDTH } from './styles'

export const PrismsPd = ({ lens }: { lens: 'r' | 'l' }) => {
  const values = useWatch()

  return (
    <Input
      center
      disabled
      style={{ width: WIDTH }}
      value={`${getPrismLensPd(values, lens)?.toFixed(2) || '0.00'}`}
    />
  )
}
